import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDTeamLoad(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdTeamLoad(period),
    queryFn: () => dashboardApi.getMDTeamLoad(period),
  });
}
